import { render } from "./RedemptionGuide.vue?vue&type=template&id=607a1ee8"
import script from "./RedemptionGuide.vue?vue&type=script&lang=js"
export * from "./RedemptionGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__